import { Component, Mixins } from "vue-property-decorator";
import ProductsServicesMixin from '@/mixins/ProductsServicesMixin';

@Component
export default class BreadCrumb extends Mixins(ProductsServicesMixin) {
    get hasCrumbs() {
        return this.crumbs && this.crumbs.length > 1;
    }

    get crumbs() {
        const pathArray = this.$route.path.split("/");
        return pathArray.reduce((breadcrumbArray: any, path, idx) => {
            const text = this.getText(path, idx);
            if (!text) {
                return breadcrumbArray;
            }

            const prevItem = breadcrumbArray[idx - 1];
            const prevPath = prevItem && prevItem.path;

            const breadcrumbItem = {
                path: path,
                to: prevPath ? `/${prevPath}/${path}` : `/${path}`,
                text: text,
            };

            return [...breadcrumbArray, breadcrumbItem];
        }, []);
    }

    getText(path: string, index: number) {
        const residentialRegex = /residential/ig;
        const routeData = this.$route.matched[index];
        let pathName: string = routeData && routeData.meta && routeData.meta.breadCrumb ? routeData.meta.breadCrumb : path;
        if(!pathName) {
            return '';
        } else if (this.isBusinessServices && residentialRegex.test(pathName)) {
            pathName = pathName.replace(residentialRegex, 'Business');
        }
        return decodeURIComponent(pathName);
    }

    get isCurrentPageCartReview () {
        return this.$route.meta && this.$route.meta.isCartReview
    }
}